export interface JobOpportunity {
  fileUrl: string;
}
